import type { NPCConfig } from '@/entities';
import type { DialogTree } from '@/types/DialogTypes';
import V2Day1Part0NPC from "@/config/NPCConfigs/v2/V2Day1Part0NPC.ts";
import V2Day1PrologueDialogue from "@/config/NPCConfigs/v2/V2Day1PrologoueDialog.ts";
import V2Day1Part1Dialog from "@/config/NPCConfigs/v2/V2Day1Part1Dialog.ts";
import V2Day1Part1NPCs from "@/config/NPCConfigs/v2/V2Day1Part1NPCs.ts";
import V2Day1Part2NPCs from "@/config/NPCConfigs/v2/V2Day1Part2NPCs.ts";
import V2Day1Part3NPCs from "@/config/NPCConfigs/v2/V2Day1Part3NPCs";
import V2Day1Part4NPCs from "@/config/NPCConfigs/v2/V2Day1Part4NPCs";
import V2Day1Part5StartingDialog from "@/config/NPCConfigs/v2/V2Day1Part5StartingDialog.ts";
import V2Day1Part4StartingDialog from "@/config/NPCConfigs/v2/V2Day1Part4StartingDialog.ts";
import V2Day1Part5NPCs from "@/config/NPCConfigs/v2/V2Day1Part5NPCs.ts";
import V2Day2Part1StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part1StartingDialog";
import V2Day2Part1NPCs from "@/config/NPCConfigs/v2/V2Day2Part1ANPCs.ts";
import V2Day2PartA2NPCs from "@/config/NPCConfigs/v2/V2Day2Part1BNPCs.ts";
import V2Day2Part2NPCs from "@/config/NPCConfigs/v2/V2Day2Part2NPCs";
import V2Day2Part2StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part2StartingDialog";
import V2Day2Part3StartingDialog from "@/config/NPCConfigs/v2/V2Day2Part3StartingDialog";
import V2Day2Part3NPCs from "@/config/NPCConfigs/v2/V2Day2Part3NPCs";
import V2Day3Part1StartingDialog from "@/config/NPCConfigs/v2/V2Day3Part1StartingDialog";
import V2Day3Part1aNPCs from "@/config/NPCConfigs/v2/V2Day3Part1aNPCs";
import V2Day3Part1bNPCs from "@/config/NPCConfigs/v2/V2Day3Part1bNPCs";
import V2Day3Part1cNPCs from "@/config/NPCConfigs/v2/V2Day3Part1cNPCs";
import V2Day3Part1dNPCs from "@/config/NPCConfigs/v2/V2Day3Part1dNPCs";
import V2Day3Part1eNPCs from "@/config/NPCConfigs/v2/V2Day3Part1eNPCs";
import V2Day3PartBadEndingExitTownNPCs from "@/config/NPCConfigs/v2/V2Day3PartBadEndingExitTownNPCs";
import V2Day3Part2NPCs from "@/config/NPCConfigs/v2/V2Day3Part2NPCs";
import V2SharedNPCs from "@/config/NPCConfigs/v2/V2SharedNPCs";
import V2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs";
import V2TEMPSECRET from "@/config/NPCConfigs/v2/V2TEMPSECRET.ts";

export interface DayConfig {
  day: number;
  dayString?:string;
  dayIcon?:"sunrise"|"day"|"sunset"|"night"
  name: string;
  description?: string;
  progress?: number;
  npcs: NPCConfig[];
  initialDialog?: DialogTree; // Optional initial dialog that plays when the day starts
  position?: { x: number; y: number };
  facing?: string; // Optional facing direction (N, NE, E, SE, S, SW, W, NW)
  music?: string; // Sound ID for background music for this day
}

const DAY_CONFIGS: DayConfig[] = [
  {
    day: 1,
    dayString : "Prolog",
    name: 'Pulang',
    description:
      '',
    progress: 0.0,
    npcs: [
      ...V2Day1Part0NPC, ...V2Day1SharedNPCs,
    ],
    music:'standing_by',
    initialDialog: {
      ...V2Day1PrologueDialogue,
    },
  },
  {
    day: 2,
    dayString : "Hari 1 ",
    name: 'Petualangan',
    description:
      '• Cari kado untuk Diana\n• Cari Diana',
    progress: 0.0625,
    npcs: [...V2Day1Part1NPCs, ...V2SharedNPCs],
    music:'standing_by',
    dayIcon : "sunrise",
  },
  {
    day: 3,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Cari kado untuk Diana',
    progress: 0.125,
    npcs: [...V2Day1Part2NPCs, ...V2SharedNPCs],
    music:'standing_by',
    dayIcon : "day"
  },
  //TODO: Choices baru sampe sini
  {
    day: 4,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Cari kado untuk Diana\n• Bertemu dengan yang lain di Danau',
    progress: 0.1875,
    npcs: [...V2Day1Part3NPCs, ...V2SharedNPCs],
    music:'standing_by',
    dayIcon : "day"
  },
  {
    day: 5,
    dayString : "Hari 1",
    name: 'Pencarian',
    description:
        '• Cari tahu tentang kematian Sondakh\n• Pergi ke Gereja dengan Romo dan lainnya',
    progress: 0.25,
    npcs: [...V2Day1Part4NPCs, ...V2SharedNPCs],
    music:'standing_by',
    dayIcon : "day"
  },
  {
    day: 6,
    dayString : "Hari 1",
    name: 'Petualangan',
    description:
        '• Bersihkan nama Diana dan Elsa\n• Kembali ke Diana',
    progress: 0.3125,
    npcs: [...V2Day1Part5NPCs, ...V2SharedNPCs],
    position : {
      x : 2370, y: 800
    },
    facing : 'NW',
    music:'standing_by',
    dayIcon : "sunset"
  },
  {
    day: 7,
    dayString : "Hari 2",
    name: '',
    description: '',
    progress: 0.375,
    npcs: [...V2Day2Part1NPCs, ...V2SharedNPCs],
    position : {
      x: 1880, y: 1545,
    },
    facing : 'S',
    music:'standing_by',
    dayIcon : "sunrise"
  },
  {
    day: 8,
    dayString : "Hari 2",
    name: '',
    description: '',
    progress: 0.4375,
    npcs: [...V2Day2PartA2NPCs, ...V2SharedNPCs],
    //TODO tambah yan panic disini pas ktm mayat
    music:'standing_by',
    // initialDialog: {
    //   startDialogId: 'op1',
    //   nodes: {
    //     op1: {
    //       id: 'op1',
    //       speaker: 'Romo Darius',
    //       text: `Tuhan Memberkati. Saya pergi dulu ya`,
    //       characterImage: '/assets/character/v2/darius.png',
    //       backgroundImage: '/assets/backdrop/desa.ktx2',
    //       isEnd : true
    //     },
    //   },
    // },
    dayIcon : "sunrise"
  },
  {
    day: 9,
    dayString : "Hari 2",
    name: '',
    description:
        '• Cari tahu tentang kematian Diana\n• Ke Gereja untuk Misa',
    progress: 0.5,
    npcs: [...V2Day2Part2NPCs],
    position : {
      x: 1880, y: 1545,
    },
    facing : 'S',
    music:'standing_by',
    dayIcon : "day"
  },
  {
    day: 10,
    dayString : "Hari 2",
    name: '',
    position : {
      x: 2350,
      y: 750,
    },
    facing : 'NW',
    description:
        '• Pulang dan beristirahat',
    progress: 0.5625,
    npcs: [...V2Day2Part3NPCs],
    music:'standing_by',
    dayIcon : "sunset"
  },
  {
    day: 11,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    progress: 0.625,
    npcs: [...V2Day3Part1aNPCs],
    music:'standing_by',
    dayIcon : "night"
  },
  {
    day: 12,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    progress: 0.6875,
    npcs: [...V2Day3Part1bNPCs],
    music:'standing_by',
    dayIcon : "night"
  },
  {
    day: 13,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    progress: 0.75,
    npcs: [...V2Day3Part1cNPCs],
    music:'standing_by',
    dayIcon : "night"
  },
  {
    day: 14,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    progress: 0.8125,
    npcs: [...V2Day3Part1dNPCs],
    //TODO tambahin yan simpatethic
    music:'bad_chase_scene',
    dayIcon : "night"
  },
  {
    day: 15,
    dayString : "Hari 3",
    name: '',
    description: '• Ikuti Elsa dan pulang',
    progress: 0.875,
    npcs: [...V2Day3PartBadEndingExitTownNPCs],
    music:'bad_chase_scene',
    dayIcon : "night"
  },
  //TODO: expresi baru sampe atas sini
  {
    day: 16,
    dayString : "Hari 3",
    name: '',
    description: '• Buktikan Elsa tidak bersalah',
    progress: 0.9375,
    npcs: [...V2Day3Part2NPCs],
    music:'standing_by',
    position : {
      x: 1800,
      y: 1320,
    },
    facing : "W",
    dayIcon : "sunrise"
  },
  {
    day: 17,
    dayString : "Prolog",
    name: 'All Ending',
    description:
      '',
    progress: 1.0,
    npcs: [
      ...V2TEMPSECRET
    ],
    music:'standing_by',
  },
];

export const dayConfigs: DayConfig[] = DAY_CONFIGS
